import { Component, ViewChild, ElementRef, OnInit, ViewEncapsulation, Renderer2 } from '@angular/core';
import { MainService } from './core/main.service';
import { AppConfig } from '../environments/environment';
import { BrowserModule, DomSanitizer } from '@angular/platform-browser'
import { Title } from "@angular/platform-browser";
import { Subscription, interval, timer } from 'rxjs';
import { scan, takeWhile, last } from 'rxjs/operators';
import { ElectronService } from 'ngx-electron';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AppComponent {

  public debug: boolean = false;
  public smallerScreen: boolean;

  private datasServer: any;
  public datasName: any;
  public base: string;
  public datas: any;

  private activityDelay: number = 5 * 60 * 1000; //ms
  private activitySubscription: Subscription;

  private step3Delay: number = 10 * 1000; //ms
  private step3DelaySubscription: Subscription;

  public debugTxt: string;

  public current: string = 'loading';
  // loading, splash, video ?!
  // phase1, phase2, phase3
  public step: number; // index des question ou étapes...
  public selected: Array<any>;

  public bgImage: any;
  public bgImageTab: any;

  public isVP: any;

  public pausedVideo: boolean;
  public playingVideo: boolean;
  public endedVideo: boolean;
  public currentVideo: string;
  public loop: boolean;
  private videoFolders: any;
  private videoSubscription: Subscription;

  public question;
  public answers: Array<any>;
  public timecodes: Array<any>;
  public timeLeft: string;
  public speeches: Array<any>;
  public dialog;
  public typing;

  private writeCharSubscription: Subscription;
  private writeEndSubscription: Subscription;
  private dialogSubscription: Subscription;

  private espaces: Array<any> = [
    {
      name: 'Végétale',
      color: '#fbab18'
    },
    {
      name: 'Animale',
      color: '#ee4991'
    },
    {
      name: 'Humaine',
      color: '#00aab0'
    },
    {
      name: 'Artificielle',
      color: '#ef4023'
    }
  ];
  public espace = this.espaces[3];


  @ViewChild('video', { static: false }) videoTag: ElementRef;
  videoProgress: number = 0;

  constructor(
    private service: MainService,
    private titleService: Title,
    private electron: ElectronService,
    public sanitizer: DomSanitizer,
    private renderer: Renderer2
  ) {
    console.log('constructor');
  }

  ngOnInit(): void {
    this.log('ngOnInit');

    if (window.hasOwnProperty('process') && window['process'].hasOwnProperty('versions') && window['process']['versions'].hasOwnProperty('electron')) { // electron
      let response: any = this.electron.ipcRenderer.sendSync('ping');
      this.datasName = response.datas;
      this.service.base = response.base;
      this.base = this.service.base;
    } else {
      this.datasName = this.findGetParameter('datas');
      this.base = AppConfig.datasServer;
      this.renderer.addClass(document.documentElement, 'web');
    }
    this.log("this.datasName", this.datasName);

    window.addEventListener('idal-contact-event', (e) => {
      let info = e['detail'];
      this.log("Input contact name: " + info.name);
      let port = info.values.findIndex(elt => elt);
      if (port == 0) {

      }
    });
    this.checkIfVP();

    this.smallerScreen = (window.devicePixelRatio < 1 || window.innerWidth != 1920 * 2 + 1280);
    this.loadDatas();
  }

  checkIfVP(): void {
    // Detect Wave System player in VP330 ou VP320
    this.isVP = navigator.userAgent.search("WSPlayer") != -1;
  }
  loadDatas(): void {
    this.current = 'loading';
    this.service.loadDatas(this.datasName).subscribe((datas => {
      this.datas = datas;
      console.log(this.datas);
      this.titleService.setTitle(this.datas.name);

      this.service.loadVideoFolders(this.datasName).subscribe((datas) => {
        this.videoFolders = datas;
        this.start();
      });

    }));
  }

  start(): void {
    this.bgImage = this.sanitizer.bypassSecurityTrustStyle('url(' + this.base + this.datasName + '/files/' + this.datas.image + ')');
    this.goHome();
  }
  goHome(): void {
    this.stopVideo();
    if (this.writeCharSubscription){
      this.writeCharSubscription.unsubscribe();
      delete this.writeCharSubscription;
    }
    if (this.writeEndSubscription){
      this.writeEndSubscription.unsubscribe();
      delete this.writeEndSubscription;
    }
    if (this.dialogSubscription){
      this.dialogSubscription.unsubscribe();
      delete this.dialogSubscription;
    }
    if (this.step3DelaySubscription) {
      this.step3DelaySubscription.unsubscribe();
      delete this.step3DelaySubscription;
    }
    this.current = 'splash';
  }

  runPhase(num: number): void {
    this['runPhase' + num]();
  }

  // ACTIVITY VS SLEEP ///////////////////////////////////////////////////////////////////////////

  onClick(): void {
    if (this.activitySubscription) {
      this.activitySubscription.unsubscribe();
      delete this.activitySubscription;
    }
    this.activitySubscription = timer(this.activityDelay).subscribe(() => {
      this.log("activitySubscription");
      // this.goHome();
      window.location.href = window.location+"index.html";
    });
  }

  // SPLASH ///////////////////////////////////////////////////////////////////////////

  onSplashClick(): void {
    // if (AppConfig.name == 'web') {
    //   if (!document.fullscreenElement) { document.documentElement.requestFullscreen(); }
    // }
    // this.runPhase(1);
    // this.runPhase(2);
  }

  // PHASE I ///////////////////////////////////////////////////////////////////////////

  runPhase1(): void {
    this.current = 'phase1';

    this.timecodes = [];
    this.timecodes = this.datas.phase1.questions.map((question) => { return { question: question, status: 'todo' } }); // todo, doing, done

    this.playVideo({ base: this.datas.phase1.video }, false);
    // this.p1_showQuestion(0);
  }
  p1_showQuestion(question): void {
    this.question = question;
    this.selected = [];
  }
  p1_getInstruction(): string {
    let msg = '';
    if (this.question) {
      let length = this.question.answers.length;
      let count = this.selected.filter((select) => select.success).length;
      if (count == 0) {
        msg = this.datas.phase1.msg0;
      } else if (count == length) {
        msg = this.datas.phase1.msg2;
      } else {
        msg = this.datas.phase1.msg1;
      }
      if (msg) {
        msg = count + '/' + length + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' + msg;
      }
    }
    return msg;
  }
  p1_getPicto(techno): string {
    return '';
  }
  p1_onTechno(techno): void {
    let answer = this.question.answers.find((answer) => answer.id == techno.id);
    if (!this.selected.find((select) => select.techno == techno)) {
      this.selected.push({ techno: techno, success: !!answer });
    }
    if (this.p1_questionFinie()) {
      this.selected = this.selected.filter((select) => select.success);
    }
  }
  p1_isCorrect(techno): boolean {
    let ret = false;
    if (this.question) {
      ret = !!this.question.answers.find((answer) => answer.id == techno.id);
    }
    return ret;
  }
  p1_getBubble(techno): string {
    let ret = '';
    if (this.question) {
      let answer = this.question.answers.find((answer) => answer.id == techno.id);
      if (answer) {
        ret = answer.answer;
      }
    }
    return ret;
  }
  p1_isSelected(techno): boolean {
    let ret = false;
    if (this.selected) {
      ret = !!this.selected.find((select) => select.techno == techno);
    }
    return ret;
  }
  p1_questionFinie(): boolean {
    let ret = false;
    if (this.question && this.selected) {
      let count = this.selected.filter((select) => select.success).length;
      let length = this.question.answers.length;
      ret = (count == length);
    }
    return ret;
  }
  p1_onNext(): void {
    delete this.question;
    this.unpauseVideo();
  }


  // PHASE II //////////////////////////////////////////////////////////////////////////

  runPhase2(): void {
    this.current = 'phase2';

    this.p2_showQuestion(0);
  }
  p2_showQuestion(num: number): void {
    this.step = num;
    this.endedVideo = false;
    this.question = this.datas.phase2.questions[this.step];
    this.selected = [];
    this.playVideo({ base: this.question.video, inc: this.step }, false);
  }
  p2_onSelect(answer): void {
    if (!this.p2_questionFinie()) {
      this.selected = [answer];
    }
  }
  p2_isSelected(answer): boolean {
    let ret = false;
    if (this.selected) {
      ret = !!this.selected.find((select) => select == answer);
    }
    return ret;
  }
  p2_questionFinie(): boolean {
    return !!this.selected.length;
  }
  p2_onNext(): void {
    if (this.step + 1 < this.datas.phase2.questions.length) {
      this.p2_showQuestion(this.step + 1);
    } else {
      // this.runPhase3();
      this.goHome();
    }
  }

  // PHASE III //////////////////////////////////////////////////////////////////////////

  runPhase3(): void {
    this.current = 'phase3';
    this.playVideo({ base: this.datas.phase3.video }, false);
    this.speeches = [];
    this.bgImageTab = this.sanitizer.bypassSecurityTrustStyle('url(' + this.base + this.datasName + '/files/' + this.datas.phase3.image + ')');
    this.step3DelaySubscription = timer(this.step3Delay).subscribe(() => {
      // this.log("step3DelaySubscription");
      this.p3_addDialog('0');
    });

  }
  p3_addDialog(id: string = undefined) {
    this.dialog = this.datas.phase3.story.find((dialog) => dialog.id == id);
    if (this.dialog) {
      this.dialogSubscription = this.p3_writeThis('car', this.dialog.text).subscribe(() => {
        if (!this.dialog.buttons.length) {
          if (this.dialog.next) {
            this.p3_addDialog(this.dialog.next);
          } else {
            this.goHome();
            // alert('### END ###');
          }
        }
      });
    }
  }
  p3_onSelect(answer): void {
    console.log('answer', answer);
    this.dialogSubscription = this.p3_writeThis('driver', answer.text).subscribe(() => {
      if (answer.id) {
        this.p3_addDialog(answer.id);
      }
    });
  }
  p3_writeThis(character: string, text: string) {
    this.typing = true;
    this.speeches.push(
      {
        character: character,
        text: '...'
      }
    );
    let delay = 50;
    if (character == 'car'){
      delay = 2000;
    }

    text = this.decodeHtmlEntities((this.stripTags(text)));
    console.log(text);
    let obs = timer(delay, 50).pipe(takeWhile(t => t<text.length));
    this.writeCharSubscription = obs.subscribe((val) => {
      if (val == 0){
        this.speeches[this.speeches.length-1].text = '';
      }
      this.speeches[this.speeches.length-1].text += text[val];
    });
    let obsEnd = obs.pipe(last());
    this.writeEndSubscription = obsEnd.subscribe(() => {
      this.typing = false;
    });
    return obsEnd;
  }
  p3_isSelected(answer): boolean {
    let ret = false;
    return ret;
  }
  p3_fini(): boolean {
    return false;
  }
  p3_onNext(): void {
    // if (this.step+1 < this.datas.phase2.questions.length){
    //   this.p3_addDialog(this.step+1);
    // } else {
    //   this.runPhase3();
    // }
  }


  // RESTART ///////////////////////////////////////////////////////////////////////////

  onRestart(): void {
    this.goHome();
  }

  // VIDEO TOOLS ///////////////////////////////////////////////////////////////////////////

  playVideo(folderBaseAndInc, loop) {
    this.log('***********');
    this.playingVideo = true;
    let folder: string = folderBaseAndInc.base;

    let folderSplit = folder.split('*');
    if (folderSplit.length > 1) {
      let num = parseInt(folderSplit.shift());
      if (folderBaseAndInc.inc != null) {
        num += folderBaseAndInc.inc;
      }
      folder = this.toStringLen(num, 3) + folderSplit.join('');
    }

    if (this.isVP) {
      this.playVideoExt(folder);
    } else {
      this.playVideoWeb(folder, loop);
    }
  }
  playVideoWeb(videoFolder: string, loop: boolean) {
    this.loop = loop;
    let sel = this.videoFolders.filter((elt) => elt.folder == videoFolder);
    if (sel.length) {
      this.currentVideo = videoFolder + '/' + sel[0].video;
      this.videoSubscription = interval(1000).subscribe(() => {
        this.videoUpdate();
      });
    }
  }
  playVideoExt(videoFolder: string) {
    this.currentVideo = videoFolder;

    let folderSplit = videoFolder.split('/');
    let folderNum = parseInt(folderSplit.shift());
    // let toPlay = this.videoFolders.filter((videoFolder) => video == videoFolder.video);
    // let folder = parseInt(toPlay[0].folder);

    this.log(window['IDAL'].getControlInterfaces);
    window['IDAL'].getControlInterfaces().then((ifaces) => {
      this.log('got ifaces');
      this.log("load", folderNum);

      ifaces.player.stop().then(() => {
        ifaces.player.playFolder(folderNum).then((ret) => {
          this.log('playing');
        }).catch(function(error) {
          this.log("control interface error");
          // Faire quelque chose d'utile...
        });
      });
    });
  }

  pauseVideo(): void {
    this.pausedVideo = true;
    if (this.isVP) {
      // this.stopVideoExt();
    } else {
      this.pauseVideoWeb();
    }
  }
  pauseVideoWeb(): void {
    this.videoTag.nativeElement.pause();
  }
  unpauseVideo(): void {
    this.pausedVideo = false;
    if (this.isVP) {
      // this.stopVideoExt();
    } else {
      this.unpauseVideoWeb();
    }
  }
  unpauseVideoWeb(): void {
    this.videoTag.nativeElement.play();
  }
  stopVideo(): void {
    this.playingVideo = false;
    if (this.isVP) {
      this.stopVideoExt();
    } else {
      this.stopVideoWeb();
    }
  }
  stopVideoWeb(): void {
    delete this.loop;
    this.currentVideo = '';
    if (this.videoSubscription) {
      this.videoSubscription.unsubscribe();
      delete this.videoSubscription;
    }
  }
  stopVideoExt(): void {
    delete this.loop;
    this.currentVideo = '';
    window['IDAL'].getControlInterfaces().then((ifaces) => {
      ifaces.player.stop();
    });
  }

  getPoster(videoSrc) {
    return videoSrc.replace('.mp4', '.jpg');
  }
  videoUpdate() {
    if (this.videoTag && this.videoTag.nativeElement) {
      this.videoProgress = Math.round(100 * this.videoTag.nativeElement.currentTime / this.videoTag.nativeElement.duration);
    } else {
      this.videoProgress = 0;
    }

    if (this.current == 'phase1') {
      let question;
      let timeLeft: string = '';
      this.timecodes.forEach((timecode) => {
        if (this.videoTag.nativeElement.currentTime < parseInt(timecode.question.timecode)) {
          timecode.status = 'todo';
        } else if (this.videoTag.nativeElement.currentTime > parseInt(timecode.question.timecode) + parseInt(timecode.question.delay)) {
          timecode.status = 'done';
        } else {
          timecode.status = 'doing';
          question = timecode.question;
        }
      });

      if (question) {
        timeLeft = '' + Math.floor(1 + parseInt(question.delay) - this.videoTag.nativeElement.currentTime + parseInt(question.timecode));
        if (question != this.question) {
          this.p1_showQuestion(question);
        }
      } else {
        delete this.question;
      }
      this.timeLeft = timeLeft;
    }
  }
  onVideoEnded(e) {
    if (this.current == 'phase1') {
      this.stopVideo();
      this.goHome();
      // this.runPhase2();
    } if (this.current == 'phase2') {
      if (this.question.question){
        this.endedVideo = true;
      } else {
        this.goHome();
      }
    } else if (this.current == 'phase3') {
      this.goHome();
    }
  }
  onVideoClick() {
    // this.current = 'splash';
  }

  // OTHER TOOLS ///////////////////////////////////////////////////////////////////////////

  toStringLen(num: number, len: number): string {
    let ret = '' + num;
    while (ret.length < len) {
      ret = '0' + ret;
    }
    return ret;
  }

  log(...txts: any): void {
    if (true || this.isVP) {
      this.debugTxt += txts.join(', ');
      this.debugTxt += '<br>';
    } else {
      this.log(...txts);
    }
  }

  findGetParameter(parameterName: string): void {
    let result = null,
      tmp = [];
    let items = location.search.substr(1).split("&");
    for (let index = 0; index < items.length; index++) {
      tmp = items[index].split("=");
      if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
    }
    return result;
  }

  stripTags(text: string): string {
    text = text.replace(/<\/p>/gi, "\r\n");
    text = text.replace(/<br>/gi, "\r\n");
    text = text.replace(/<br \/>/gi, "\r\n");
    // text = text.replace(/(<([^>]+)>)/gi, "");
    // text = text.substring(0, text.length-2);
    return text;
  }
  decodeHtmlEntities(text: string): string {
    text = text.replace(/\r\n/gi, "[br]");
    let element = document.createElement('div');
    element.innerHTML = text;
    text = element.textContent;
    text = text.replace(/\[br\]/gi, "\r\n");
    return text;
  }
  addP(text: string): string {
    text = text.trim();
    if (text.substring(0, 2) != "<p"){
      text = '<p>'+text+'</p>';
    }
    return text;
  }


}
